module.exports = __webpack_public_path__ + "static/table-color-6af1b574438f309d75c23f5e5ec648d1.svg";